import React, { useReducer, useContext } from "react";
import { useHistory } from "react-router-dom";
// import axios from "axios";
import axios from "../../axiosinstance";
import AuthContext from "./AuthContext";
import AuthReducer from "./AuthReducer";
import setAuthToken from "../../utils/setAuthToken";
import {
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_REQUEST_SUCCESS,
  RESET_REQUEST_FAIL,
  CLEAR_ERRORS,
  REGISTER_SUCCESS,
  REGISTER_FAILED
} from "../types";

// Contexts
import LayoutContext from "../layout/LayoutContext";

const AuthState = (props) => {
  const initialState = {
    token: localStorage.getItem("token"),
    isAuthenticated: false,
    loading: true,
    user: null,
    reset_message: null,
    reset_request: false,
    error: null,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const { clearAlerts } = useContext(LayoutContext);

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const history = useHistory();

  // Load User
  const loadUser = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);

      try {
        const validateConfig = {
          headers: {
            "Content-Type": "application/json",
            "authorization": "Bearer " + localStorage.token
          },
        };

        const validateBody = {
          "token": localStorage.token
        }

        const res = await axios.post("/api/auth/validate-token", validateBody, validateConfig);
        if(res.error) {
          dispatch({
            type: AUTH_ERROR,
          });
        }
      } catch (e) {
        dispatch({
          type: AUTH_ERROR,
        });
      }

      try {
        const res = await axios.get("/api/auth/getUser");

        dispatch({
          type: USER_LOADED,
          payload: res.data,
        });

        clearAlerts();
      } catch (err) {
        dispatch({
          type: AUTH_ERROR,
        });
      }
    } else {
      dispatch({
        type: AUTH_ERROR,
      });
    }
  };

  const registerUser = async (formData) => {
    try {
      const res = await axios.post("/api/auth/register", formData, config);

      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data,
      });

      clearAlerts();
      return res
    } catch (err) {
      dispatch({
        type: REGISTER_FAILED,
        payload: err.response.data.message,
      });
      return err.response
    }
  };

  // Login User
  const login = async (formData) => {
    try {
      const res = await axios.post("/api/auth/login", formData, config);

      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data,
      });

      clearAlerts();
      loadUser();
    } catch (err) {
      dispatch({
        type: LOGIN_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

  // Logout
  const logout = () => {
    clearAlerts();
    dispatch({
      type: LOGOUT,
    });
  };

  // Change Password
  const changePassword = async (formData) => {
    try {
      const res = await axios.put("/api/users/password", formData, config);

      dispatch({
        type: CHANGE_PASSWORD_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: CHANGE_PASSWORD_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

  // Forget Password (Send Email)
  const forgetPassword = async (email) => {
    try {
      const res = await axios.post(
        "/api/auth/request-reset-password",
        {
          email,
        },
        config
      );

      dispatch({
        type: RESET_PASSWORD_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: RESET_PASSWORD_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

  // Reset Password Request (Check User Account)
  const resetPasswordRequest = async (token) => {
    try {
      const res = await axios.post(
        "/api/auth/reset-request",
        {
          token,
        },
        config
      );

      dispatch({
        type: RESET_REQUEST_SUCCESS,
        payload: res.data.message === "Reset request accepted." ? true : false,
      });
    } catch (err) {
      dispatch({
        type: RESET_REQUEST_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

  // Reset Password
  const resetPassword = async (formData) => {
    try {
      const res = await axios.post(
        "/api/auth/reset-password",
        {
          formData,
        },
        config
      );
      
      dispatch({
        type: RESET_PASSWORD_SUCCESS,
        payload: res.data,
      });
      return res
    } catch (err) {
      dispatch({
        type: RESET_PASSWORD_FAIL,
        payload: err.response.data.message,
      });

      return err
    }
  };

  // Clear Errors
  const clearErrors = () =>
    dispatch({
      type: CLEAR_ERRORS,
    });

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        loading: state.loading,
        user: state.user,
        reset_message: state.reset_message,
        reset_request: state.reset_request,
        error: state.error,
        loadUser,
        registerUser,
        login,
        logout,
        changePassword,
        forgetPassword,
        resetPassword,
        resetPasswordRequest,
        clearErrors,
      }}
    >
      {" "}
      {props.children}{" "}
    </AuthContext.Provider>
  );
};

export default AuthState;
